import styles from "./CcpaDeleteSummary.module.scss";

const CCPA_RESOURCE_LABELS = {
    account: "Account",
    orders: "Orders",
    idp_user: "IDP user",
};

const ccpaResourceLabel = type => CCPA_RESOURCE_LABELS[type] ?? type;

const CcpaDeleteSummary = ({ result }) => {
    const resources = result?.deleted_resources ?? [];
    const message =
        result?.message ||
        (result?.success
            ? "Customer data deleted successfully"
            : "Failed to delete customer data");

    return (
        <div className={styles.result}>
            <p className={styles.message}>{message}</p>
            {resources.length > 0 ? (
                <ul className={styles.list}>
                    {resources.map(resource => (
                        <li
                            className={styles.item}
                            key={resource.resource_type}
                        >
                            <span className={styles.type}>
                                {ccpaResourceLabel(resource.resource_type)} ·{" "}
                                {resource.count} deleted
                            </span>
                            {resource.resource_ids?.length ? (
                                <span className={styles.ids}>
                                    {resource.resource_ids.join(", ")}
                                </span>
                            ) : null}
                        </li>
                    ))}
                </ul>
            ) : null}
        </div>
    );
};

export default CcpaDeleteSummary;
